import { render, staticRenderFns } from "./EntityContactsPane.vue?vue&type=template&id=34730052&"
import script from "./EntityContactsPane.vue?vue&type=script&lang=js&"
export * from "./EntityContactsPane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports